<span class="icon inline-loader small" style="height: 1rem; width: 1rem"></span>
  